import { render, staticRenderFns } from "./checkBarcode.vue?vue&type=template&id=80bb6af6&scoped=true"
import script from "./checkBarcode.vue?vue&type=script&lang=js"
export * from "./checkBarcode.vue?vue&type=script&lang=js"
import style0 from "./checkBarcode.vue?vue&type=style&index=0&id=80bb6af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bb6af6",
  null
  
)

export default component.exports